module.exports = __webpack_public_path__ + "static/media/TYC_Marketplace.dbaebc8d.pdf";